var _excluded = ["htmlFor", "hideLabel", "labelText", "optionalText", "children", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { node, string, bool } from 'prop-types';
import classNames from 'classnames';
import './Label.scss';
var propTypes = {
  /** Attach label to id of form control */
  htmlFor: string.isRequired,

  /** Label text */
  labelText: string.isRequired,
  children: node,

  /** Visually hide the label */
  hideLabel: bool,

  /** Text describing the input as optional */
  optionalText: string,

  /** Add your own custom class names to the component */
  className: string
};
/** The Label component represents a caption for a form element/component. */

var Label = function Label(_ref) {
  var htmlFor = _ref.htmlFor,
      hideLabel = _ref.hideLabel,
      labelText = _ref.labelText,
      optionalText = _ref.optionalText,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-label', {
    'rds-is-vishidden': hideLabel
  }, className);
  var labelTextClassNames = classNames('rds-label__text');
  return /*#__PURE__*/React.createElement("label", _extends({
    htmlFor: htmlFor,
    className: componentClassNames
  }, rest), children, /*#__PURE__*/React.createElement("span", {
    className: labelTextClassNames
  }, labelText), optionalText && /*#__PURE__*/React.createElement("small", {
    className: "rds-label__optional"
  }, "(", optionalText, ")"));
};

Label.propTypes = propTypes;
export default Label;